
var Model = require("../types/Model.js");

// TODO: Be more smart with added and removed events

/**
 * Keeps track of the contact list, and the contacts' data
 * @type {Model}
 */
module.exports = Model({
	name: "contacts",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_contacts: null, // The array of contact ids
	_people: null,

	recalculate: recalculate,
	refresh: refresh,
});

/**
 * Adds listeners for changes in the contact list, changes in the people store, and fetches the initial state
 * @return {Promise} Resolves to the initial state
 */
function init() {
	this._contacts = [];
	this._people = {};

	this.refresh();

	this.push([]);
}

/**
 * Removes all listeners from the dispatcher and the people store
 * @return {Promise} Resolves after everything is done.
 */
function uninit() {
	this._contacts = null;
	this._people = null;
}

function listeners() {
	return {
		"mqtt:$/contacts/added": handle_added,
		"mqtt:$/contacts/removed": handle_removed,
		"connectivity:online": refresh,
		"people:updated": handle_people_updated,
	};
}

function triggers() {
	return {
		"remove": handle_trigger_remove,
	};
}

function handle_trigger_remove(data) {
	var who = data.who;
	this.emit("save:trigger:start");

	if (!who) return;
	this.api.contacts.remove(who)
		.then(refresh.bind(this))
		.catch(console.error.bind(console))
		.then(removeFinished.bind(this));

	this.emit("usermetrics:trigger:track", "remove contact from contact list", { who });
}

function removeFinished() {
	var message = "contactlist.removed";
	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});
	this.emit("save:trigger:finish");
}

function recalculate() {
	var people = this._people;
	var contacts = this._contacts;

	this.push(contacts.reduce(function (list, id) {
		var person = people[id];
		if (person) list.push(person);
		return list;
	}, []));
}

function handle_added(data) {
	var id = data.user;
	if (this._contacts.indexOf(id) !== -1) return;
	this._contacts.push(id);
	this.recalculate();
	this.emit("people:trigger:add", {
		lean: true,
		who: [id]
	});
}

function handle_removed(data) {
	var id = data.user;
	var oldSize = this._contacts.length;

	this._contacts = this._contacts.filter(function (existing) {
		return existing !== id;
	});

	if (this._contacts.length !== oldSize) this.recalculate();
}

function handle_people_updated(people) {
	this._people = people;
	this.recalculate();
}

/**
 * Refreshes the contact list and adds all contacts to be watched by the people store
 * @return {Promise} Resolves when everything is refreshed and passed to people store
 */
function refresh() {
	return this.api.contacts.list() // Get the contacts list
		.then(set_contacts.bind(this)) // Set _contacts on the store
		.then(track_people.bind(this)); // Add all contacts to people store
}

function track_people(who) {
	this.emit("people:trigger:add", {
		lean: true,
		who: who
	});
}

/**
 * Really kinda self-explanatory
 */
function set_contacts(contacts) {
	this._contacts = contacts;
	this.recalculate();
	return contacts;
}
